import { render, staticRenderFns } from "./app_logo.vue?vue&type=template&id=0b28c1f0&scoped=true&"
import script from "./app_logo.vue?vue&type=script&lang=js&"
export * from "./app_logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b28c1f0",
  null
  
)

export default component.exports